/**
 * Stats tracker — which tracker a SMSWiser campaign's stats come from.
 * For Media Devoted | Created By Ciro Autiero
 *
 * The country payload carries `trafficProvider` as the DB enum. A row without
 * one (linked before Binom existed) has always been read as Voluum and still
 * is; every known value — Tres Commas included — keeps its own tracker and is
 * never relabelled Voluum or Binom.
 */

import {
  assertNever,
  parseTrackerEnum,
  trackerFromEnum,
  trackerLabel,
  type TrackerEnum,
  type TrackerId,
} from '@trafficpulse/shared';

/** Campaign `trafficProvider` → the stats view's provider (DB enum spelling). */
export function statsTrafficProvider(raw: string | null | undefined): TrackerEnum {
  return parseTrackerEnum(raw) ?? 'VOLUUM';
}

/** Same, as the lowercase tracker id the tracker-scoped hooks take. */
export function statsTrackerId(raw: string | null | undefined): TrackerId {
  return trackerFromEnum(statsTrafficProvider(raw));
}

/** The stats page's tracker-source toggle label for the active group's tracker. */
export function statsSourceLabel(provider: TrackerEnum): string {
  switch (provider) {
    case 'VOLUUM':
    case 'BINOM':
      return 'Voluum / Binom';
    case 'TRES_COMMAS':
      return trackerLabel('tres-commas');
    default:
      return assertNever(provider, 'traffic provider');
  }
}
